import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

import { GetPartnerLogosResponse } from './types/get-partner-logos.type';

export const getPartnerLogos = async (
	locale = 'en'
): Promise<AxiosResponse<GetPartnerLogosResponse>> => {
	const response = await api.get(`/nav/${locale}/partners`);

	return response;
};
